<template>
  <v-btn
    class="px-2"
    :elevation="elevation"
    :color="color"
    :variant="$store.state.isDarkMode ? 'outlined' : 'flat'"
    v-bind="$attrs"
  >
    <v-icon
      v-if="icon"
      :size="resolvedIconSize"
      class="mr-1"
    >{{ icon }}</v-icon>
    <span>{{ label }}</span>
  </v-btn>
</template>

<script>
export default {
  name: 'BaseViewBtn',

  props: {
    label: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: 'primary',
    },
    iconSize: {
      type: String,
      default: 'small',
    },
    elevation: {
      type: [Number, String],
      default: 1,
    },
  },

  computed: {
    resolvedIconSize() {
      if (this.iconSize === 'x-large') return 'x-large';
      if (this.iconSize === 'large') return 'large';
      if (this.iconSize === 'x-small') return 'x-small';
      return 'small';
    },
  },
};
</script>
